module.exports = __webpack_public_path__ + "img/history_gallery_1.942b2cf2.png";